
const enum TimestampType {
    'Before',
    'After',
    'Meanwhile'

};
import { Marketdate } from '../marketdate';
import { User } from '../../shared';
import { Electricmeter } from '../electricmeter';
export class MarketdateMeterreading {
    constructor(
        public id?: number,
        public value?: number,
        public timestampType?: TimestampType,
        public timestamp?: any,
        public updated?: any,
        public created?: any,
        public marketdate?: Marketdate,
        public updatedBy?: User,
        public electricmeter?: Electricmeter,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-meterreading/marketdate-meterreading.model.ts